<template>
    <div>
        <PageHeader :page_title="page_title"/>
        <pSpinner v-if="loading"></pSpinner>
        <template v-if="!loading">
            <v-form ref="form">
                <div class="ml-3 mr-3">
                <v-alert :value="alert" class="cyb-alert-error mt-3"  >No such active deposit<v-icon  @click = "alert = false" style="padding-bottom: 8px;float: right;font-size: 19.5px;font-weight: bold;line-height: 1;"  class="close_hover" >close</v-icon></v-alert> 
                </div>
                <v-layout row wrap fluid align-center class="mt-1 ml-2">
                    <v-flex md2  xs12 class="pr-3 ml-2">
                        <v-select menu-props="offsetY" item-text="name" item-value="id" :items="types" v-model="type_id" label="Type" name="type_id"></v-select>
                    </v-flex> 
                    
                    <v-btn slot="activator" xs12 sm6   class="mb-3"  dark color="primary" @click="search" >Show</v-btn>
                    
                </v-layout> 
                <v-container fluid  class="mb-1 pt-0">
                
                    <v-layout row wrap v-if="!show_loan">
                        <DepositMeta v-for="(deposit, index) in deposit_list" :deposit="deposit"></DepositMeta>
                    </v-layout>
                    <v-layout row wrap v-if="show_loan" class="ml-1">
                        <v-flex xs12 sm12 md12>
                            <div class="text-md-left text-lg-left text-xs-left">No deposits found</div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
        </template>
    </div>
</template>

<script>

  import axios from 'axios';

  import NoData from '@/components/NoData';
  
  import pSpinner from '@/components/pSpinner';
  
  import global from '@/components/rbconstants';
  
  import PageHeader from '@/components/PageHeader';
  
  import DepositMeta from '@/components/DepositMeta';
  
  export default {

    components : {

        NoData      : NoData,
        
        PageHeader  : PageHeader,
        
        DepositMeta : DepositMeta,
        
        pSpinner    : pSpinner,
        
    },  
    
    mounted() {
        
        this.getDataFromApi()
        
        .then(data => {
            
            this.deposit_list = data.deposit_list.deposit_list;
            
            if(this.deposit_list[0]['no_data']) {
            
                this.show_loan = true
            
            } else {
            
                this.show_loan = false
                
            }
            
            this.types = data.deposit_list.types;
            
            this.loading = false;
          
        })
        
    },
      
    data: () => ({
        
        page_title : "Deposit List",
        
        type_id : '',
        
        types : [],
       
        deposit_list : [],
        
        alert: false,
        
        loading : false,
        
        show_loan: false,
        
        table_headers : [{ text: '#'}, { text : 'Account Number'}, { text : 'Product'}, { text : 'Status'}, { text : 'Branch'},
                        { text : 'Deposit Date'}],
                        
    }),
    
	methods : {
	    
        getDataFromApi() {
            
            this.loading = true;
           
            this.table_loading = true
            
            return new Promise((resolve, reject) => {
            
                var app = this;
                
                app.alert = app.$route.params.alert
                
                var form_post_data = {};
                
                axios.get(global.links.deposit_list+'?deposit_type='+ app.type_id+'&deposit_status='+app.status_id, {
                
                    params : form_post_data,
                    
                    headers: global.header
                
                
                }) .then(function (response) {
                
                    if(response.status == 200) {
                        
                        var deposit_list = response.data.data;
                        
                        setTimeout(() => {
                            
                            app.loading = false;
                            
                            app.table_loading = false
                            
                            resolve({
                                
                                deposit_list
                            
                            })
                        
                        }, 1000)
                    
                    }
                
                }) .catch(function (error) {
                    
                    app.loading = false;
                    
                });
                    
            });
        },
        
        search : function () {
            
            this.getDataFromApi()
            
            .then(data => {
            
              this.deposit_list = data.deposit_list.deposit_list;
              
              if(this.deposit_list[0]['no_data']) {
                  
                  this.show_loan = true
                  
              } else {
                  
                  this.show_loan = false
              }
                            
              this.types = data.deposit_list.types;
              
              this.loading = false;
              
            })
            
        },
       
        view_details : function(deposit_id, product_id, view_link) {
                
                if(product_id == 2) {
                    
                    this.$router.push({ name: 'FixedDeposit', params: { id: deposit_id}});
                }
                
                if(product_id == 1) {
                    
                    this.$router.push({ name: 'SavingsDeposit', params: { id: deposit_id}});
                }
                
                if(product_id == 3) {
                    
                    this.$router.push({ name: 'CumulativeDeposit', params: { id: deposit_id}});
                }
                
                if(product_id == 4) {
                    
                    this.$router.push({ name: 'RecurringDeposit', params: { id: deposit_id}});
                }
                
                if(product_id == 5) {
                    
                    this.$router.push({ name: 'GoldLoan', params: { id: deposit_id}});
                }
                
                if(product_id == 11) {
                    
                    this.$router.push({ name: 'PropertyLoan', params: { id: deposit_id}});
                }
                
                if(product_id == 16) {
                    
                    this.$router.push({ name: 'BusinessLoan', params: { id: deposit_id}});
                }
                
                
            }, 
            
        view_ledger : function(deposit_id, product_id, view_link) {
                
                if(product_id == 2) {
                    
                    this.$router.push({ name: 'FixedDepositLedger', params: { id: deposit_id}});
                }
                
                 if(product_id == 1) {
                    
                    this.$router.push({ name: 'SavingsDepositLedger', params: { id: deposit_id}});
                }
                 
                if(product_id == 3) {
                    
                    this.$router.push({ name: 'CumulativeDepositLedger', params: { id: deposit_id}});
                }
                
                 if(product_id == 4) {
                    
                    this.$router.push({ name: 'RecurringDepositLedger', params: { id: deposit_id}});
                }
                
                if(product_id == 5) {
                    
                    this.$router.push({ name: 'GoldLoanLedger', params: { id: deposit_id}});
                }
                
                if(product_id == 11) {
                    
                    this.$router.push({ name: 'PropertyLoanLedger', params: { id: deposit_id}});
                }
                
                if(product_id == 16) {
                    
                    this.$router.push({ name: 'BusinessLoanLedger', params: { id: deposit_id}});
                }
            }, 
            
        get_blnc : function(rb_account_id) {
            
            var app = this;
            
            var link = global.links.deposit_balance;
            
            link = link.replace(':id', rb_account_id)
            
            document.getElementById("blnc_text"+rb_account_id).style.display = 'none';
            document.getElementById("blnc_loading_text"+rb_account_id).style.display = 'block';
            
            var form_post_data = {};
            axios.get(link, {
                
                params : form_post_data,
            
                headers: global.header
                
            }) .then(function (response) {
                //app.loading = false;
                if(response.status == 200) {
                    var balance = response.data.data.balance;
                    setTimeout(() => {
                    app.table_loading = false
                    document.getElementById("blnc_loading_text"+rb_account_id).innerHTML = balance;
                  }, 1000)
                    
                }
                
            }) .catch(function (error) {
                
                document.getElementById("blnc_text"+rb_account_id).style.display = 'block';
                document.getElementById("blnc_loading_text"+rb_account_id).style.display = 'none';
                
            });
            
            
        }
        
	},

  }
  
</script>

<style scoped>

    
    .cyb-alert-error {
        color: #a94442  !important; 
        border: 1px solid #ebccd1 !important;
        border-radius: 4px !important;
        background-color: #f2dede !important;
        border-color: #f2dede !important;
        /*margin-left: 24px !important;*/
        /*margin-right: 20px !important;*/
        /*padding-left: 16px !important;*/
        padding-top: 8px !important;
        padding-bottom: 2px !important;
        margin-bottom: 2px !important;
    }
    
        
    .close_hover{ color: 	#808080 !important;}
    .close_hover:hover {color: rgba(0,0,0,0.87) !important;}

</style>